/* jcb Football Effects — WM Edition */
(function () {
  const config = window.__jcbFootballConfig || {};

  /* ── Custom cursor ── */
  if (config.cursor) {
    const cursorEl = document.createElement('div');
    cursorEl.className = 'jcb-cursor-ball';
    cursorEl.setAttribute('aria-hidden', 'true');
    cursorEl.textContent = '⚽';
    document.body.appendChild(cursorEl);
    document.documentElement.classList.add('jcb-football-cursor-active');

    let raf;
    document.addEventListener('mousemove', (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        cursorEl.style.transform = `translate(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%))`;
      });
    });

    document.addEventListener('mouseleave', () => {
      cursorEl.style.display = 'none';
    });
    document.addEventListener('mouseenter', () => {
      cursorEl.style.display = 'block';
    });
  }

  /* ── Floating balls ── */
  const count = Math.min(Math.max(parseInt(config.ballCount) || 4, 1), 8);

  const positions = [
    { left: '5%',  top: '70%', duration: 16, delay: 0,   dx1:  35, dy1: -55, dx2: -25, dy2: -110, dx3:  45, dy3: -75, dx4: -15, dy4: -150 },
    { left: '20%', top: '80%', duration: 19, delay: 2,   dx1: -40, dy1: -65, dx2:  30, dy2: -130, dx3: -50, dy3: -85, dx4:  20, dy4: -170 },
    { left: '50%', top: '75%', duration: 14, delay: 5,   dx1:  30, dy1: -50, dx2: -20, dy2: -105, dx3:  40, dy3: -70, dx4: -10, dy4: -145 },
    { left: '72%', top: '82%', duration: 18, delay: 1,   dx1: -35, dy1: -60, dx2:  25, dy2: -120, dx3: -45, dy3: -80, dx4:  15, dy4: -160 },
    { left: '88%', top: '68%', duration: 21, delay: 3.5, dx1:  45, dy1: -70, dx2: -35, dy2: -140, dx3:  55, dy3: -90, dx4: -25, dy4: -180 },
    { left: '35%', top: '85%', duration: 17, delay: 7,   dx1: -30, dy1: -45, dx2:  20, dy2:  -95, dx3: -40, dy3: -65, dx4:  10, dy4: -135 },
    { left: '62%', top: '90%', duration: 15, delay: 4,   dx1:  25, dy1: -55, dx2: -15, dy2: -110, dx3:  35, dy3: -75, dx4:  -5, dy4: -150 },
    { left: '92%', top: '78%', duration: 20, delay: 6,   dx1: -45, dy1: -65, dx2:  35, dy2: -130, dx3: -55, dy3: -85, dx4:  25, dy4: -170 },
  ];

  const container = document.createElement('div');
  container.className = 'jcb-floating-balls';
  container.setAttribute('aria-hidden', 'true');

  for (let i = 0; i < count; i++) {
    const p = positions[i % positions.length];
    const ball = document.createElement('div');
    ball.className = 'jcb-ball';
    ball.textContent = '⚽';
    ball.style.cssText = [
      `left:${p.left}`,
      `top:${p.top}`,
      `--jcb-duration:${p.duration}s`,
      `--jcb-delay:${p.delay}s`,
      `--jcb-dx1:${p.dx1}px`,
      `--jcb-dy1:${p.dy1}px`,
      `--jcb-dx2:${p.dx2}px`,
      `--jcb-dy2:${p.dy2}px`,
      `--jcb-dx3:${p.dx3}px`,
      `--jcb-dy3:${p.dy3}px`,
      `--jcb-dx4:${p.dx4}px`,
      `--jcb-dy4:${p.dy4}px`,
    ].join(';');
    container.appendChild(ball);
  }

  document.body.appendChild(container);
})();
